import React from "react";
import Logo from "../assets/Logo.png";
import AppStore from "../assets/appstore.svg";
import gplay from "../assets/gplay.png";

const GOOGLE_GROUP_URL = "https://groups.google.com/u/1/g/urban-samurai-test";
const GOOGLE_GROUP_EMAIL = "urban-samurai-test@googlegroups.com";

const DevNews = ({ t }) => {
    const copy = t.devNews;

    return (
        <>
            <section className="alpha">
                <div className="alpha-card">
                    <div className="alpha-head">
                        <h1>{copy.title}</h1>
                        <p className="alpha-subtitle">{copy.subtitle}</p>
                    </div>

                    <div className="alpha-grid">
                        <div className="alpha-panel alpha-panel--steps">
                            <h3 className="alpha-title">{copy.howToAccess}</h3>

                            <ol className="alpha-steps">
                                <li>
                                    {copy.steps[0]}{" "}
                                    <a className="alpha-link" href={GOOGLE_GROUP_URL} target="_blank" rel="noopener noreferrer">
                                        {GOOGLE_GROUP_URL}
                                    </a>
                                </li>
                                <li>{copy.steps[1]}</li>
                                <li>{copy.steps[2]}</li>
                                <li>{copy.steps[3]}</li>
                            </ol>

                            <div className="alpha-callout alpha-callout--danger">
                                <strong>{copy.importantTitle}</strong> {copy.importantText}
                            </div>
                        </div>

                        <div className="alpha-panel alpha-panel--cta">
                            <a
                                href={GOOGLE_GROUP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="alpha-cta neon-white-button"
                                data-text={copy.cta}
                            >
                                <span>{copy.cta}</span>
                            </a>

                            <div className="alpha-contact">
                                <div className="alpha-contact-label">{copy.contactSupport}</div>
                                <a className="alpha-link" href={`mailto:${GOOGLE_GROUP_EMAIL}`}>
                                    {GOOGLE_GROUP_EMAIL}
                                </a>
                            </div>

                            <div className="alpha-callout alpha-callout--warn">
                                <strong>{copy.warningTitle}</strong> {copy.warningText}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer className="basement">
                <div className="footer-item">
                    <a
                        href="https://play.google.com/store/apps/details?id=tr.production_hell.urban_samurai&utm_campaign=productionhell&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={copy.gplayAria}
                    >
                        <img className="storemin-gplay" alt="Get it on Google Play" src={gplay} />
                    </a>
                </div>

                <div className="logomin">
                    <img height="120" width="220" src={Logo} alt={copy.logoAlt} />
                </div>

                <div className="footer-item" aria-label={copy.iosComingAria} title={copy.iosComingTitle}>
                    <img className="storemin-appstore" src={AppStore} alt={copy.appStoreAlt} />
                </div>
            </footer>
        </>
    );
};

export default DevNews;
